<template>
    <div class="err-modal p10" v-show="isShow">
        <el-card class="box-card">
            <p class="font14px mt10 mb10 tac">您当前选择的对比日期为 <span class="text-color-error">不完整日期</span> 对比，建议您切换数据汇总方式为日均，进行日均数据对比。</p>
            <p class="tac">
                <el-button type="primary" size="mini" @click="close" style="margin-left: 120px;">关闭</el-button>
                <span class="text-color-gray inline-block" style="width:120px; " v-if="seconds>0">（{{seconds}}秒后自动关闭）</span>
            </p>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "DateTips",
        data(){
            return {
                isShow:false,
                timer:null,
                seconds:15,
            }
        },
        methods:{
            show(){
                this.isShow = true;
                this.autoPlay();
            },
            close(){
                this.isShow = false;
                clearTimeout(this.timer);
                this.timer = null;
                this.seconds = 15;
            },
            autoPlay(){
                this.timer = setTimeout(()=>{
                    this.seconds--;
                    if(this.seconds>0){
                        this.autoPlay();
                    }else{
                        this.close();
                    }
                },1000)
            }
        }
    }
</script>

<style scoped>
    .err-modal{
        position: fixed;
        width: 800px;
        left: 50%;
        margin-left: -400px;
        top: 150px;
        z-index: 3000;
    }
    .box-card{
        border: 1px solid #ccc;
    }
</style>
